import { gql } from '@apollo/client';

export const REPLICATE_LATEST_EMISSION_FACTOR_TO_COMPANY = gql`
  mutation ReplicateMasterListEmissionFactorsToCompany(
    $input: ReplicateMasterListEmissionFactorsToCompanyRequest!
  ) {
    replicateMasterListEmissionFactorsToCompany(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result
    }
  }
`;

export const CREATE_EMISSION_FACTOR = gql`
  mutation CreateEmissionFactor($input: CreateEmissionFactorRequest!) {
    createEmissionFactor(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        start_date
        end_date
        factor
        source
        deleted
        metric
        metric_group
        target_year
        category
        country
      }
    }
  }
`;

export const UPDATE_EMISSION_FACTOR = gql`
  mutation UpdateEmissionFactor($input: UpdateEmissionFactorRequest!) {
    updateEmissionFactor(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        start_date
        end_date
        factor
        source
        deleted
        metric
        metric_group
        target_year
        category
        country
      }
    }
  }
`;

export const SOFT_DELETE_EMISSION_FACTOR = gql`
  mutation SoftDeleteEmissionFactor($input: SoftDeleteEmissionFactorRequest!) {
    softDeleteEmissionFactor(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        deleted
      }
    }
  }
`;
